// packages/web-ui/src/AppShell/ContextPanel-modes/SkillsCollapsed.tsx
//
// Skills destination collapses the context panel to 0 px width (mirrors
// SettingsCollapsed). The full editor lives in the main `<TabContentArea>`
// surface — the context panel has nothing to render on this destination.

import type { JSX } from 'react';

export function SkillsCollapsed(): JSX.Element {
  return (
    <div
      data-testid="skills-mode-root"
      aria-hidden="true"
      className="sr-only"
    />
  );
}
